export default "__VITE_ASSET__CpKDlMx2__"